import clsx from 'clsx';
import {
  isValidElement,
  type ReactNode,
  type SVGTextElementAttributes,
} from 'react';

import {
  elementLabelWrapper,
  foreignObjectContainer,
  textContainer,
} from './GaugeLabel.sty.js';
import { GaugeResponsiveLabel } from '../GaugeResponsiveLabel/GaugeResponsiveLabel.js';

interface GaugeLabelProps extends SVGTextElementAttributes<SVGTextElement> {
  value: ReactNode;
  autoHide?: boolean;
  responsive?: boolean;
}

export const GaugeLabel = ({
  value,
  autoHide,
  responsive,
  ...textProps
}: GaugeLabelProps) => {
  const isElement = isValidElement(value);

  if (isElement && responsive) {
    return value;
  }

  if (responsive) {
    return (
      <GaugeResponsiveLabel text={value?.toString() ?? ''} id={textProps.id} />
    );
  }

  if (isElement) {
    return (
      <foreignObject
        x={textProps.x}
        y={textProps.y}
        fontSize={textProps.fontSize}
        className={elementLabelWrapper}
      >
        <div
          className={clsx(
            foreignObjectContainer({
              dominantBaseline: textProps.dominantBaseline,
            }),
            { [textContainer]: autoHide },
          )}
        >
          {value}
        </div>
      </foreignObject>
    );
  }

  return (
    <text
      textAnchor="middle"
      dominantBaseline="hanging"
      {...textProps}
      className={clsx({ [textContainer]: autoHide })}
    >
      {value}
    </text>
  );
};
